// Image Studio reuses the lifestyle-coverage summary endpoint — the
// catalog grid pulls per-product persona coverage from the SAME REST
// shape the retired /image-gen page used. The dispatch path is
// different though: Image Studio drives catalog.generateLifestyleImages
// through the agent chat (so it inherits styles[], countPerSegment, and
// Phase 4 useProducerSeedPicker for free), not the dedicated REST
// kickoff. kickoffGenerate therefore does NOT live here — it's gone
// with the old page.

import { apiJson } from '../../auth/apiFetch';

export type PersonaSummary = {
  _id:       string;
  name:      string;
  avatarUrl: string | null;
};

export type PersonaCell = {
  personaId:   string;
  artifactId:  string | null;
  imageUrl:    string;
  generatedAt: string;
  count:       number;
};

export type SummaryProduct = {
  productId:           string;
  title:               string;
  heroUrl:             string | null;
  categoryName:        string | null;
  coveredPersonaCount: number;
  totalPersonas:       number;
  latestGeneratedAt:   string | null;
  personaCoverage:     PersonaCell[];
};

export type SummaryResponse = {
  brand:         { _id: string; name: string };
  personas:      PersonaSummary[];
  products:      SummaryProduct[];
  productsTotal: number;
  hasMore:       boolean;
  limit:         number;
  offset:        number;
};

export function fetchSummary(brandId: string, opts: {
  search?: string; categoryId?: string; limit?: number; offset?: number;
}): Promise<SummaryResponse> {
  const params = new URLSearchParams();
  if (opts.search)     params.set('search',     opts.search);
  if (opts.categoryId) params.set('categoryId', opts.categoryId);
  if (opts.limit != null)  params.set('limit',  String(opts.limit));
  if (opts.offset != null) params.set('offset', String(opts.offset));
  const qs = params.toString() ? `?${params.toString()}` : '';
  return apiJson<SummaryResponse>(`/api/brand/${brandId}/lifestyle-summary${qs}`);
}
